import { useSupportService } from '@/layout/appWrapper/ServiceProvider';
import { contactFormEmail } from '@/stores/contactFormStore';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { useLocalization } from '@/services/localizationService';
import TextField from '../TextField';

function getErrorMessage(
  email: string,
  isEmailValid: boolean,
  isActive: boolean,
  message: string
) {
  if (!isActive) return;
  if (email.length === 0) return;
  if (!isEmailValid) return message;
}

function useIsErrorActive() {
  const [isActive, setIsActive] = useState(false);
  const activateError = () => setIsActive(true);
  return [isActive, activateError] as const;
}

export default function EmailField() {
  const [email, setEmail] = useRecoilState(contactFormEmail);
  const { useIsEmailValid } = useSupportService();
  const isEmailValid = useIsEmailValid();
  const [isErrorActive, activateError] = useIsErrorActive();
  const { data } = useLocalization();
  return (
    <div onBlur={activateError}>
      <TextField
        placeHolder={data.support.email}
        value={email}
        onChange={setEmail}
        className="mt-4"
        maxLength={100}
        errorMessage={getErrorMessage(
          email,
          isEmailValid,
          isErrorActive,
          data.support.emailAddressValidation
        )}
      />
    </div>
  );
}
